import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["bordered", "endSlot", "middleSlot", "startSlot"];
import { useTheme } from 'foundations-theming/utils';
import { AbstractToolbar } from '../AbstractToolbar/AbstractToolbar';
import { InnerFlex } from '../AbstractToolbar/InnerFlex';
import { SlotFlex } from '../AbstractToolbar/SlotFlex';
import { TabBarProvider } from './TabBarProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const TabBarMiddle = ({
  children
}) => {
  return /*#__PURE__*/_jsx(SlotFlex, {
    position: "middle",
    flexBasis: "auto",
    flexGrow: 1,
    maxBlockSize: "100%",
    minBlockSize: "50px",
    minInlineSize: "50px",
    maxInlineSize: "100%",
    children: children
  });
};
const TabBarInner = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(InnerFlex, Object.assign({
    paddingInlineStart: "200"
  }, props, {
    children: children
  }));
};
const TabBarStart = ({
  children
}) => {
  return /*#__PURE__*/_jsx(SlotFlex, {
    position: "start",
    flexBasis: 'auto',
    flexGrow: 0,
    flexShrink: 0,
    children: children
  });
};
const TabBarEnd = ({
  children
}) => {
  return /*#__PURE__*/_jsx(SlotFlex, {
    position: "end",
    flexBasis: 'auto',
    flexGrow: 0,
    flexShrink: 0,
    children: children
  });
};

/**
 * Center the buttons in the tab bar
 */
const buttonWrapperStyleOverrides = {
  justify: 'center'
};

/**
 * Remove TabPanel's border
 * @see https://git.hubteam.com/HubSpot/foundations-components/blob/15c70a0a02f6ea415810a1f1c197b2dc1f2c91e5/foundations-components/static-1.7735/js/transitional/components/Tabs/Tabs.tsx#L111-L152
 */
const tabPanelStyleOverrides = {
  borderBlockStart: 'none'
};

/**
 * Ensure the tab wrapper fills the full width of the container
 */
const tabsStyleOverrides = {
  flexGrow: 1
};
export const TabBar = _ref2 => {
  let {
      bordered = false,
      endSlot,
      middleSlot,
      startSlot
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const theme = useTheme();

  /**
   * Remove the border from Tabs when used in a TabBar to avoid double borders
   */
  const tabBorderStyleOverrides = {
    border: theme.color['fill-transparent-default']
  };
  return /*#__PURE__*/_jsx(TabBarProvider, {
    buttonWrapperStyleOverrides: buttonWrapperStyleOverrides,
    tabPanelStyleOverrides: tabPanelStyleOverrides,
    tabsStyleOverrides: tabsStyleOverrides,
    tabBorderStyleOverrides: tabBorderStyleOverrides,
    children: /*#__PURE__*/_jsx(AbstractToolbar, Object.assign({
      borderBlockEndStyle: bordered ? 'solid' : undefined,
      borderBlockEndColor: bordered ? 'border-core-subtle' : undefined,
      borderBlockEndWidth: bordered ? '100' : undefined,
      paddingBlockStart: "500",
      paddingInlineEnd: "500",
      End: TabBarEnd,
      endSlot: endSlot,
      Inner: TabBarInner,
      Middle: TabBarMiddle,
      middleSlot: middleSlot,
      responsive: false,
      Start: TabBarStart,
      startSlot: startSlot
    }, rest))
  });
};
TabBar.displayName = 'TabBar';